
import KnImageToBase64IconPicker from '@/components/UI/KnImageToBase64IconPicker.vue'
import Dialog from 'primevue/dialog'
import icons from './icons.json'
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'IconPicker',
    emits: ['chooseIcon', 'closeFontAwesomeModal'],
    components: { Dialog, KnImageToBase64IconPicker },
    props: ['showModal'],
    watch: {
        showModal: {
            handler: function(show) {
                this.modalShown = show
            }
        }
    },
    data() {
        return {
            modalShown: false,
            disableChoosen: false,
            selected: '',
            chosenIcon: {} as any,
            localIcons: [] as Array<any>
        }
    },
    mounted() {
        this.localIcons = icons.icons.filter((i) => i.membership.free.length > 0)
    },
    methods: {
        getIcon(icon) {
            this.selected = icon.id
            this.chosenIcon = icon
            this.disableChoosen = false
        },
        chooseIcon() {
            if (this.chosenIcon) {
                this.$emit('chooseIcon', this.chosenIcon)
            }
        },
        closeModal() {
            this.$emit('closeFontAwesomeModal')
        },
        filterIcons(event) {
            const search = event.target.value.trim()
            let filter = [] as Array<any>
            if (search.length > 1) {
                filter = icons.icons.filter((item) => {
                    const regex = new RegExp(search, 'gi')
                    return item.id.match(regex) && item.membership.free.length > 0
                })
            } else if (search.length === 0) {
                this.localIcons = icons.icons.filter((i) => i.membership.free.length > 0)
            }
            if (filter.length > 0) {
                this.localIcons = filter
            }
        },
        toggleDisableChooseButton(value) {
            this.disableChoosen = value
        },
        onBase64ImageSelection(image) {
            this.chosenIcon = image
            this.$emit('chooseIcon', image)
        }
    }
})
